/**
 * Relative cue for a garment deadline date (ex-factory / delivery):
 * overdue (bad) · today/this week (warn) · later (muted). Lifted from the
 * styles list page when the Orders list became its second consumer (§7
 * rule 17 — the second usage is when you stop and refactor).
 */
export function dateRelative(iso: string | null): { label: string; className: string } | null {
  if (!iso) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const target = new Date(`${iso}T00:00:00`);
  const days = Math.round((target.getTime() - today.getTime()) / 86_400_000);
  if (days < 0) return { label: `${Math.abs(days)}d overdue`, className: "text-bad" };
  if (days === 0) return { label: "today", className: "text-warn" };
  if (days <= 7) return { label: `in ${days}d`, className: "text-warn" };
  return { label: `in ${days}d`, className: "text-muted" };
}
